var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:save"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 9.33334V25.3333C28 26.0667 27.7387 26.6947 27.216 27.2173C26.6933 27.74 26.0658 28.0009 25.3333 28H6.66667C5.93334 28 5.30534 27.7387 4.78267 27.216C4.26 26.6933 3.99911 26.0658 4 25.3333V6.66667C4 5.93334 4.26134 5.30534 4.784 4.78267C5.30667 4.26 5.93422 3.99911 6.66667 4H22.6667L28 9.33334ZM16 24C17.1111 24 18.0556 23.6111 18.8333 22.8333C19.6111 22.0556 20 21.1111 20 20C20 18.8889 19.6111 17.9444 18.8333 17.1667C18.0556 16.3889 17.1111 16 16 16C14.8889 16 13.9444 16.3889 13.1667 17.1667C12.3889 17.9444 12 18.8889 12 20C12 21.1111 12.3889 22.0556 13.1667 22.8333C13.9444 23.6111 14.8889 24 16 24ZM8 13.3333H20V8H8V13.3333Z",
    fill: "#30293E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.9434bff2274201db87321a56b3718fb6.svg";
export { ForwardRef as ReactComponent };